module.exports = __webpack_public_path__ + "img/img-4.2486bfe2.png";